/**
 * What a run's state means, and how it is shown.
 *
 * Every table in the console asks the same question of a state — did this
 * work — so the answer lives here once. Keeping the word and the color
 * together is deliberate: they are one decision rendered two ways, and kept
 * apart, a view grows its own copy of the state vocabulary and the two can
 * disagree about what "aborted" means.
 */import{styles}from"web/shared/jobs/jobsViews.styles.js";// The states that mean "this did not work". Anything else terminal is
// treated as success.
const UNHEALTHY_RUN_STATES=["FAILED","ABORTED"];/** The pill style for a run or dispatch state (null = no run yet). */export function runStateStyle(state){if(state==null){return styles.statusNeutral;}if(state==="RUNNING"){return styles.statusRunning;}if(UNHEALTHY_RUN_STATES.includes(state)){return styles.statusBad;}if(state==="SUCCEEDED"||state==="COMPLETED"){return styles.statusGood;}return styles.statusNeutral;}/**
 * The short status word for a job, from its latest run.
 *
 * Never-run is its own status rather than being folded into "ok" — it is the
 * state that most often means something is misconfigured, and a job that has
 * never run is the most important row on the page.
 */export function latestRunLabel(latestRun){if(latestRun==null){return"never run";}if(latestRun.state==="SUCCEEDED"){return"ok";}return latestRun.state.toLowerCase();}